import { render } from "./BillingConfirmDialog.vue?vue&type=template&id=4effa316&scoped=true"
import script from "./BillingConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./BillingConfirmDialog.vue?vue&type=script&lang=ts"

import "./BillingConfirmDialog.vue?vue&type=style&index=0&id=4effa316&lang=scss&scoped=true"
import "./BillingConfirmDialog.vue?vue&type=style&index=1&id=4effa316&lang=scss"
script.render = render
script.__scopeId = "data-v-4effa316"

export default script